import React from 'react';
import { queryKeyes } from '../../shared/queryKeys';
import { useQuery } from 'react-query';
import { loadEEOI, loadImodcsGraphData, loadVesselBasicInformation } from '../../VesselMaster/vesselMaster.hooks';
import Loading from '../../Components/Loading';
import ErrorComponent from '../../Components/ErrorComponent';
import { Card, CardBody, CardHeader, Col, Label, Row } from 'reactstrap';
import VesselDetailsHeader from 'Components/VesselDetailsHeader';

const ImoDcsPartial = (vesselId: any) => {
    // const [download, setDownload] = useState(false);

    // const handleDownloadButton = (e: any) => {
    //     setDownload(!download)
    // }

    /**
     * Calculate total of the given field
    * @returns number
    */
    const totalItem = (field: string) => {
        let total = 0;
        imodcsData.filter((item: any) => {
            return total += item[field]
        })
        return isNaN(total) ? 0 : total;
    }

    /** Graph data */
    const { data: imodcsData, isLoading: imodcsloading, isError: imodcsError } = useQuery(
        [queryKeyes.vessel.IMODCSData.key, vesselId.vesselId],
        async () => {
            return await loadImodcsGraphData(parseInt(vesselId.vesselId))
        });

    /** Vessel's basic information */
    const { data: BasicInformation, isLoading: BasicInformationLoading, isError: BasicInformationError } = useQuery(
        [queryKeyes.vessel.VesselBasicInformation.key, vesselId.vesselId],
        async () => {
            return await loadVesselBasicInformation(parseInt(vesselId.vesselId))
        });

    /** EEOI */
    const { data: EEOI, isLoading: EEOILoading, isError: EEOIError } = useQuery(
        [queryKeyes.vessel.EEOI.key, vesselId.vesselId],
        async () => {
            return await loadEEOI(parseInt(vesselId.vesselId))
        });

    if (imodcsloading || BasicInformationLoading || EEOILoading) {
        return <Loading message='Loading required data!' />
    }
    if (imodcsError || BasicInformationError || EEOIError) {
        return <ErrorComponent message='Unbable to load required data' />
    }
    return (
        <div className="page-content" style={{ paddingTop: '2rem' }}>
            <Row className='mb-3'>
                <Col lg={3}>
                    <div className='pos-start'>
                        <h6 className='text-muted'>Last updated on : {imodcsData[imodcsData.length - 1]?.start_date.toString().substring(0, 10)} {imodcsData[imodcsData.length - 1]?.start_date.toString().substring(12, 16)}</h6>
                    </div>
                </Col>
                <Col lg={{ size: 2, offset: 7 }}>
                    <div className='pos-end'>
                        <VesselDetailsHeader />
                    </div>
                </Col>
                {/* <Col lg={1}>
                    <Label className='pos-end' onClick={handleDownloadButton}><i className='bx bx-download icon_s23' /></Label>
                </Col> */}
            </Row>
            <Row>
                {!(imodcsloading || BasicInformationLoading) && !(imodcsError || BasicInformationError) &&
                    <Card>
                        <CardHeader>
                            <h4>Basic information</h4>
                        </CardHeader>
                        <CardBody className='nopadbottom'>
                            <Row>
                                <Col>
                                    <div className='ele_row1'>
                                        <Label className='extra_bold_lbl'>Gross Tonnage&nbsp;</Label><Label className='bold_lbl navbar_menu mr-2'>&nbsp;:&nbsp;{BasicInformation[0]?.gross_tonnage}</Label>
                                    </div>
                                    <div className='ele_row1'>
                                        <Label className='extra_bold_lbl'>Net Tonnage&nbsp;</Label><Label className='bold_lbl navbar_menu mr-2'>&nbsp;:&nbsp;{BasicInformation[0]?.net_tonnage}</Label>
                                    </div>
                                    <div className='ele_row1'>
                                        <Label className='extra_bold_lbl'>Deadweight Tonnage&nbsp;</Label><Label className='bold_lbl navbar_menu mr-2'>&nbsp;:&nbsp;{BasicInformation[0]?.deadweight_tonnage}</Label>
                                    </div>
                                </Col>
                                <Col>
                                    <div className='ele_row1'>
                                        <Label className='extra_bold_lbl'>Ice Class&nbsp;</Label><Label className='bold_lbl mr-3'>&nbsp;:&nbsp;{BasicInformation[0]?.ice_class}</Label>
                                    </div>
                                    <div className='ele_row1'>
                                        <Label className='extra_bold_lbl'>EEDI&nbsp;</Label><Label className='bold_lbl navbar_menu'>&nbsp;:&nbsp;{BasicInformation[0]?.eedi}</Label>
                                    </div>
                                    <div className='ele_row1'>
                                        <Label className='extra_bold_lbl'>EEOI&nbsp;</Label><Label className='bold_lbl navbar_menu'>&nbsp;:&nbsp;{EEOI?.average_eeoi}</Label>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <Label className='extra_bold_lbl'>Power Output&nbsp;-&nbsp;</Label>
                                    <Row>
                                        <Col>
                                            <div className='ele_row1'>
                                                <Label className='bold_lbl'>Main propulsion power&nbsp;</Label><Label className='bold_lbl mr-2'>&nbsp;:&nbsp;{BasicInformation[0]?.main_propulsion_power}</Label>
                                            </div>
                                            <div className='ele_row1'>
                                                <Label className='bold_lbl'>Auxillary engine(s)&nbsp;</Label><Label className='bold_lbl'>&nbsp;:&nbsp;{BasicInformation[0]?.auxillary_engine}</Label>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                }
            </Row>
            <Row>
                <Card>
                    <CardHeader>
                        <h4>Total data</h4>
                    </CardHeader>
                    <CardBody className='nopadbottom'>
                        <div className="table-responsive">
                            <table className="table">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-center">Sr. No.</th>
                                        <th>Start date (dd/mm/yyyy)</th>
                                        <th>End date (dd/mm/yyyy)</th>
                                        <th>Distance travelled (nm)</th>
                                        <th>Hours underway (hr)</th>
                                        <th>Diesel/Gas oil</th>
                                        <th>Fuel Oil</th>
                                        <th>Method used to measure fuel oil consumption</th>
                                        <th>Remarks (if any)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>{imodcsData[0]?.start_date.toString().substring(0, 10)} {imodcsData[0]?.start_date.toString().substring(12, 16)}</td>
                                        <td>{imodcsData[imodcsData?.length - 2]?.end_date?.toString().substring(0, 10)} {imodcsData[imodcsData?.length - 2]?.end_date?.toString().substring(12, 16)}</td>
                                        <td>{totalItem('distance_travelled')}</td>
                                        <td>{totalItem('hours_underway')}</td>
                                        <td>{totalItem('do_fuel_consumption').toFixed(2)}</td>
                                        <td>{totalItem('fo_fuel_consumption').toFixed(2)}</td>
                                        <td>Flow Meter</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            </Row>
            <Row>
                <Card>
                    <CardHeader>
                        <h4>Daily Reporting Data</h4>
                    </CardHeader>
                    <CardBody className='nopadbottom'>
                        <div className="table-responsive vertical-table-scroll">
                            <table className="table">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-center">Sr. No.</th>
                                        <th>Start date (dd/mm/yyyy)</th>
                                        <th>End date (dd/mm/yyyy)</th>
                                        <th>Distance travelled (nm)</th>
                                        <th>Hours underway (hr)</th>
                                        <th>Diesel/Gas oil</th>
                                        <th>Fuel Oil</th>
                                        <th>Method used to measure fuel oil consumption</th>
                                        <th>Remarks (if any)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {imodcsData?.map((item: any, index: number) => {
                                        return (
                                            <tr>
                                                <td className='text-center'>{index + 1}</td>
                                                <td className='text-center'>{item.start_date?.toString().substring(0, 10)} {item.start_date?.toString().substring(12, 16)}</td>
                                                <td className='text-center'>{item.end_date?.toString().substring(0, 10)} {item.end_date?.toString().substring(12, 16)}</td>
                                                <td className='text-center'>{item.distance_travelled}</td>
                                                <td className='text-center'>{item.hours_underway}</td>
                                                <td className='text-center'>{(item.do_fuel_consumption).toFixed(2)}</td>
                                                <td className='text-center'>{(item.fo_fuel_consumption).toFixed(2)}</td>
                                                <td className='text-center'>{/*item.method_used_to_measure_fueloil_consumption*/} Flow Meter</td>
                                                <td></td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            </Row>
            <Row>
                <Card>
                    <CardHeader>
                        <h5>Footnotes:</h5>
                    </CardHeader>
                    <CardBody className='nopadbottom'>
                        <ol>
                            <li>In accordance with the IMO ship identification number scheme, adopted by the Organization by resolution A.600(15).</li>
                            <li>As defined in regulation 2 of MARPOL Annex VI or other (to be stated).</li>
                            <li>GT should be calculated in accordance with the International Convention on Tonnage Measurement of Ships, 1969. If not applicable, note “N/A”.</li>
                            <li>NT should be calculated in accordance with the International Convention on Tonnage Measurement of Ships, 1969. If not applicable, note “N/A”.</li>
                            <li>DWT means the difference in tonnes between the displacement of a ship in water of relative density of 1.025 kg/m3 at the summer load draught and the lightweight of the ship. The summer load draught should be taken as the maximum summer draught as certified in the stability booklet approved by the Administration or an organization recognized by it. If not applicable, note "N/A".</li>
                            <li>EEDI should be calculated in accordance with the IMO Resolution MEPC.245(66) on the 2014 Guidelines on the Method of Calculation of the Attained Energy Efficiency Design Index (EEDI) for New Ships, as amended.</li>
                            <li>Ice class should be consistent with the definition set out in the International Code for ships operating in polar waters (Polar Code), (resolutions MEPC.264(68) and MSC.385(94)). If not applicable, note "N/A".</li>
                            <li>Power output (rated power) of main and auxiliary reciprocating internal combustion engines over 130 kW (to be stated in kW). Rated power means the maximum continuous rated power as specified on the nameplate of the engine.</li>
                            <li>Method used to measure fuel oil consumption: 1: Method using BDNs, 2: Method using flow meters, 3: Method using bunker fuel tank monitoring.</li>
                        </ol>
                    </CardBody>
                </Card>
            </Row>
        </div>
    )
}

export default ImoDcsPartial